import React from 'react';

import { ButtonWithPreview } from 'common/components/TouchpointEditor/components/TouchpointNodes/Button';

export default function CheckInButton(props) {
    return <ButtonWithPreview {...props} />;
}

CheckInButton.splash = {
    ...ButtonWithPreview.splash,
    defaultProps: {
        ...ButtonWithPreview.splash.defaultProps,
        meta: {
            ...ButtonWithPreview.splash.defaultProps.meta,
            content: 'Check In',
        },
    },
};
